import { Badge, type BadgeTone } from '../ui/badge';
import type { SlaStatus } from '../../api/types';

const LABELS: Record<SlaStatus, string> = {
  ok: 'SLA ок',
  warn: 'SLA предупреждение',
  breach: 'SLA нарушен',
  escalated: 'SLA эскалация',
};

const TONES: Record<SlaStatus, BadgeTone> = {
  ok: 'success',
  warn: 'warning',
  breach: 'danger',
  escalated: 'danger',
};

export function SlaBadge({ sla }: { sla: SlaStatus }) {
  return <Badge tone={TONES[sla]}>{LABELS[sla]}</Badge>;
}
